import(/* webpackMode: "eager", webpackExports: ["LayoutClient"] */ "/vercel/path0/app/LayoutClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/style.scss");
